// types
import { TP_HeatingOutlet } from './types'
import { GridHeaderCell } from '../../../components/Grid'
// components
import { schema as schemaHeatingCoil } from '../../../SubPlants/SP_HeatingCoil'
import { schema as schemaCoolingCoil } from '../../../SubPlants/SP_CoolingCoil'
import { schemaFlow, schemaPFlow, schemaSFlow, schemaOutlet, schemaPOutlet, schemaSOutlet } from '../../../SubPlants/SP_Pipe'
import { LoadingView } from "../../../../components";
// api
import { useGetObjectsChildren } from '../../../../hooks/useGetObjectsChildren'
import { FormattedMessage } from 'react-intl'
import { useMemo } from 'react'
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid'
import RenderIfVisible from 'react-render-if-visible'
import { useMediaQuery } from '../../../../hooks'
import { AutomationObjectCard } from '../../../components/Grid/AutomationObjectCard'
import { PlantSwitchesGrid } from '../../components/PlantSwitches'
import { Badge } from 'baseui/badge';

export function OperatorPanel(props: TP_HeatingOutlet) {

    const { children: childElement, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)
    const flowPipe = useMemo(() => childElement?.find((v: any) => v.schema === schemaFlow), [childElement]);
    const pFlowPipe = useMemo(() => childElement?.find((v: any) => v.schema === schemaPFlow), [childElement]);
    const sFlowPipe = useMemo(() => childElement?.find((v: any) => v.schema === schemaSFlow), [childElement]);

    const outletPipes = useMemo(() => childElement?.filter((v: any) => v.schema === schemaOutlet), [childElement]);
    const pOutletPipe = useMemo(() => childElement?.find((v: any) => v.schema === schemaPOutlet), [childElement]);
    const sOutletPipe = useMemo(() => childElement?.find((v: any) => v.schema === schemaSOutlet), [childElement]);
    const heatingCoil = useMemo(() => childElement?.find((v: any) => v.schema === schemaHeatingCoil), [childElement]);
    const coolingCoil = useMemo(() => childElement?.find((v: any) => v.schema === schemaCoolingCoil), [childElement]);

    const isHighRatio = useMediaQuery("only screen and (-webkit-min-device-pixel-ratio: 1.5)");
    const columnCount = isHighRatio ? [1, 1, 2, 3] : [1, 1, 2, 4];

    return (
        <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
            <PlantSwitchesGrid childElements={childElement}></PlantSwitchesGrid>

            <>
                {(heatingCoil || flowPipe || pFlowPipe) &&
                    <GridHeaderCell header={<FormattedMessage id="P_CoolingHeating.Flow" defaultMessage="Flow" />}></GridHeaderCell>
                }
                <FlexGrid
                    flexGridColumnCount={columnCount}
                    flexGridColumnGap="scale800"
                    flexGridRowGap="scale800"
                >
                    {childElement?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.SubPlants.HeatingGenerators.SP_HeatingGenerator") ?

                            (<FlexGridItem >
                                <RenderIfVisible defaultHeight={400} visibleOffset={500} stayRendered>
                                    <AutomationObjectCard item={item}></AutomationObjectCard>
                                </RenderIfVisible>
                            </FlexGridItem>)

                            : (<></>)
                    ))}
                    {childElement?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.SubPlants.HeatingCoils.SP_HeatingCoil") ?

                            (<FlexGridItem >
                                <RenderIfVisible defaultHeight={400} visibleOffset={500} stayRendered>
                                    <AutomationObjectCard item={item}></AutomationObjectCard>
                                </RenderIfVisible>
                            </FlexGridItem>)

                            : (<></>)
                    ))}
                    {childElement?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.SubPlants.CoolingCoils.SP_CoolingCoil") ?

                            (<FlexGridItem >
                                <RenderIfVisible defaultHeight={400} visibleOffset={500} stayRendered>
                                    <AutomationObjectCard item={item}></AutomationObjectCard>
                                </RenderIfVisible>
                            </FlexGridItem>)

                            : (<></>)
                    ))}
                    {childElement?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.SubPlants.Pipes.SP_FlowPipe") ?

                            (<FlexGridItem >
                                <RenderIfVisible defaultHeight={400} visibleOffset={500} stayRendered>
                                    <AutomationObjectCard item={item}></AutomationObjectCard>
                                </RenderIfVisible>
                            </FlexGridItem>)

                            : (<></>)
                    ))}
                    {childElement?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.SubPlants.Pipes.SP_PrimaryFlowPipe") ?

                            (<FlexGridItem >
                                <RenderIfVisible defaultHeight={400} visibleOffset={500} stayRendered>
                                    <AutomationObjectCard item={item}></AutomationObjectCard>
                                </RenderIfVisible>
                            </FlexGridItem>)

                            : (<></>)
                    ))}
                </FlexGrid>
            </>
            <>
                {((outletPipes && outletPipes.length > 0) || pOutletPipe) &&
                    <GridHeaderCell header={<FormattedMessage id="P_CoolingHeating.Outlet" defaultMessage="Outlet" />}></GridHeaderCell>
                }
                <FlexGrid
                    flexGridColumnCount={columnCount}
                    flexGridColumnGap="scale800"
                    flexGridRowGap="scale800"
                >
                    {childElement?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.SubPlants.Pipes.SP_OutletPipe") ?

                            (<FlexGridItem >
                                <RenderIfVisible defaultHeight={400} visibleOffset={500} stayRendered>
                                    <AutomationObjectCard item={item}></AutomationObjectCard>
                                </RenderIfVisible>
                            </FlexGridItem>)

                            : (<></>)
                    ))}
                    {childElement?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.SubPlants.Pipes.SP_PrimaryOutletPipe") ?

                            (<FlexGridItem >
                                <RenderIfVisible defaultHeight={400} visibleOffset={500} stayRendered>
                                    <AutomationObjectCard item={item}></AutomationObjectCard>
                                </RenderIfVisible>
                            </FlexGridItem>)

                            : (<></>)
                    ))}
                </FlexGrid>
            </>
            <>
                {(sFlowPipe) &&
                    <GridHeaderCell header={<FormattedMessage id="P_CoolingHeating.FlowSecondary" defaultMessage="Flow Secondary" />}></GridHeaderCell>
                }
                <FlexGrid
                    flexGridColumnCount={columnCount}
                    flexGridColumnGap="scale800"
                    flexGridRowGap="scale800"
                >
                    {childElement?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.SubPlants.Pipes.SP_SecondaryFlowPipe") ?

                            (<FlexGridItem >
                                <RenderIfVisible defaultHeight={400} visibleOffset={500} stayRendered>
                                    <AutomationObjectCard item={item}></AutomationObjectCard>
                                </RenderIfVisible>
                            </FlexGridItem>)

                            : (<></>)
                    ))}
                </FlexGrid>
            </>
            <>
                {(sOutletPipe) &&
                    <GridHeaderCell header={<FormattedMessage id="P_CoolingHeating.OutletSecondary" defaultMessage="Outlet Secondary" />}></GridHeaderCell>
                }
                <FlexGrid
                    flexGridColumnCount={columnCount}
                    flexGridColumnGap="scale800"
                    flexGridRowGap="scale800"
                >
                    {childElement?.map((item: any, index: number) => (
                        (item.schema === "AutomationApps.SubPlants.Pipes.SP_SecondaryOutletPipe") ?

                            (<FlexGridItem >
                                <RenderIfVisible defaultHeight={400} visibleOffset={500} stayRendered>
                                    <AutomationObjectCard item={item}></AutomationObjectCard>
                                </RenderIfVisible>
                            </FlexGridItem>)

                            : (<></>)
                    ))}
                </FlexGrid>
            </>

        </LoadingView>
    );
}

